






import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import MemberCrm from '@/views/member/popup/MemberCrm.vue';// 원본
import PopupView from '@/views/PopupView.vue'

@Component({
  components: {
    PageTitle,
    AdminIframe,
    MemberCrm,
    PopupView
  },
})
export default class MemberCrmIFrame extends Vue {
  private onLoadIframe() {
    window.location.replace(process.env.VUE_APP_ADMIN_REMOTE_URL + '/crm/' + this.$route.params.memberId)
  }

  private get remoteSrc() {
    // 프리미엄 원주소 : /member/popup/crm/134204080
    // 프로 주소 : /pro/crm/131870753
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/crm/' + this.$route.params.memberId + '?' + queryString;
  }
}
